<template>
	<!--<div class="right">-->

		<!--<div class="title">登录账号</div>-->
		<!--<div class="logins">-->
			<!--<el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="input user">-->
				<!--<el-form-item label="" prop="ucode" class="box">-->
					<!--<img src="../assets/images/user.png" alt="">-->
					<!--<el-input class="ucode" v-model="ruleForm.ucode" autocomplete="off" clearable-->
							  <!--placeholder="输入用户名"></el-input>-->
				<!--</el-form-item>-->
				<!--<el-form-item label="" prop="password" class="box">-->
					<!--<img src="../assets/images/pass.png" alt="">-->
					<!--<el-input class="password" type="password" v-model="ruleForm.password" clearable-->
							  <!--placeholder="输入密码"></el-input>-->
				<!--</el-form-item>-->
				<!--<el-form-item label="" prop="xitongcode" class="box">-->
					<!--<img src="../assets/images/pass.png" alt="">-->
					<!--<el-input class="xitongcode" type="xitongcode" v-model="ruleForm.xitongcode" clearable-->
							  <!--placeholder="输入系统编码"></el-input>-->
				<!--</el-form-item>-->


			<!--</el-form>-->
			<!--<div class="forget">-->
				<!--<div class="checkBox">-->
					<!--&lt;!&ndash; <el-checkbox label="记住密码" style="margin-top:20px;"></el-checkbox> &ndash;&gt;-->
				<!--</div>-->
			<!--</div>-->
			<!--<div class="dengluSign">-->
				<!--<div class="denglu" :class="{'active':index==indx}" v-for="(item,index) in list"-->
					 <!--:key="index" @click="login(index,'ruleForm')">{{item}}-->
				<!--</div>-->
			<!--</div>-->
		<!--</div>-->
	<!--</div>-->
</template>
<script>
    import ss from '../api/SystemService'
    import store from "../store";
    import SlideVerify from '../components/vue-slide-verify.vue';

    export default {
        data() {
            return {
                flag: false,
                agreeIs: false,
                indx: 0,
                ruleForm: {
                    phone: '',
                    password: '',
                    yzm: '1234'
                },
                msg: '',
                checked: true,
                rules: {
                    ucode: [
                        {required: true, message: '请输入用户名', trigger: 'blur'}
                    ],
                    password: [
                        {required: true, message: '请输入密码', trigger: 'blur'}
                    ],
                    xitongcode: [
                        {required: true, message: '请输入验证码', trigger: 'blur'}
                    ],
                },
                list: ["登录"]
            }
        },
        created() {
            this.query();
        },
        methods: {
            // login(index, ruleForm) {
            //     ss.LoginService.logina(this.ruleForm.ucode, this.ruleForm.password, this.ruleForm.xitongcode).then(rd => {
            //         console.log(rd,"!@#!@##")
				// 	if(rd){
            //          console.log("true")
            //             ss.LoginService.loginb(rd, this.ruleForm.ucode).then(rd => {
            //                 store.commit("setUser", rd)
				// 			console.log(rd,"1111123")
            //                 this.$router.push({path: "/dingd/purchaselist"});
				// 		})
            //         }else{
            //             console.log(rd,"456789000000")
            //             console.log("11235667")
            //             this.$router.push({path: "/login"});
				// 	}
            //         //store.commit("setUser", rd)
            //     })
            // },
            query() {
                console.log("以进入")
                this.ruleForm.ucode = this.$route.query.ucode;
                console.log("this.ruleForm.ucode=="+this.ruleForm.ucode);
                this.ruleForm.password= this.$route.query.password;
                this.ruleForm.xitongcode = this.$route.query.xitongcode;
                ss.LoginService.logina(this.ruleForm.ucode, this.ruleForm.password, this.ruleForm.xitongcode).then(rd => {
                    console.log(rd,"!@#!@##")
                    if(rd){
                        console.log("true")
                        ss.LoginService.loginb(rd, this.ruleForm.ucode).then(rd => {
                            store.commit("setUser", rd)
                            console.log(rd,"1111123")
                            this.$router.push({path: "/dingd/purchaselist"});
                        })
                    }else{
                        console.log(rd,"456789000000")
                        console.log("11235667")
                        this.$router.push({path: "/login"});
                    }
                    //store.commit("setUser", rd)
                })
            },
        },
        components: {
            SlideVerify
        }
    }
</script>
<style scoped>
	.loginBox {
		width: 100%;
		height: 100%;
		background: url(../assets/images/login-bg.jpg)
	}

	.bannerBox {
		width: 80%;
		margin: 0 auto;
	}

	.titleBox {
		padding-top: 0.3rem;
		display: flex;
	}

	.titleBox p {
		font-size: 30px;
		color: #ffffff;
		padding: 0;
		margin: 0;
		line-height: 50px;
		margin-left: 38px;
	}

	.login {
		width: 100%;
		height: 7.5rem;
		display: flex;
		margin-top: 0.3rem;
	}

	.login .left {
		width: 7.2rem;
		height: 7.5rem;
		border-radius: 8px 0px 0px 8px;
		overflow: hidden;
		/* margin-left: 3%; */
		float: left;
	}

	.login .left img {
		width: 100%;
		height: 100%;
	}

	.login .right {
		width: 7.2rem;
		height: 7.5rem;
		background: #fff;
		position: relative;
		border-radius: 0 8px 8px 0px;
		overflow: auto;
	}
	.login .right::-webkit-scrollbar{
		background: #fff;
	}
	.login .right .loginright {
		position: absolute;
		top: 0;
		right: 0;
		width: 3rem;
		height: 4.8rem;
	}

	.login .right .title {
		/* position: absolute;
         top: 0.7rem;
         left: 3rem; */
		margin-top: 0.7rem;
		margin-left: 3rem;
		width: 1rem;
		text-align: center;
		font-size: 0.24rem;
		color: #128bf1;
	}

	.logins {
		width: 80%;
		/* position: absolute;
        top: 1.5rem;
        left: 0.7rem; */
		margin-top: 0.5rem;
		margin-left: 0.7rem;
		display: flex;
		flex-direction: column;
		text-align: left;
	}

	.box {
		position: relative;
		height: 0.5rem;
	}

	.box img {
		position: absolute;
		bottom: 20%;
		z-index: 1;
	}

	.wang {
		display: flex;
		margin-top: 0.2rem;
	}

	.wang .shensu {
		text-decoration: underline;
		font-size: 0.18rem;
		line-height: 30px;
		color: #128bf1;
		cursor: pointer;
	}

	.logins .buttons {
		display: inline-block;
		width: 1.6rem;
		height: 0.45rem;
		background-color: #128bf1;
		border-radius: 2px;
		color: #fff;
		font-size: 0.18rem;
		position: absolute;
		right: 0;
		bottom: 36%;
		text-align: center;
		line-height: 0.45rem;
		cursor: pointer;
	}

	.forget {
		display: flex;
		justify-content: space-between;
	}

	.dengluSign {
		margin-top: 0.3rem;
		display: flex;
		justify-content: center;
	}

	.dengluSign .denglu {
		width: 40%;
		height: 0.5rem;
		background-color: #ffffff;
		border: solid 1px #cccccc;
		border-radius: 2px;
		line-height: 0.5rem;
		text-align: center;
		cursor: pointer;
		color: #787878;
		font-size: 0.24rem;
		margin-left: 0.3rem;
	}

	.dengluSign .denglu.active {
		border: solid 1px #128bf1;
		background-color: #128bf1;
		color: #fff;
	}

	/* .shensu {
        width: 40%;
        color: #128bf1;
        font-size: 16px;
        text-decoration: underline;
        text-align: center;
        margin-left: 70%;
        margin-top: 10px;
        cursor: pointer;
    } */

	.agreeBox {
		width: 100%;
		height: 100%;
		position: fixed;
		top: 0;
		left: 0;
		background: rgba(0, 0, 0, 0.6);
		z-index: 1;
	}

	.agreeBox .agree {
		width: 50%;
		height: 80%;
		background: rgba(0, 0, 0, 0);
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		margin: auto;
	}

	.agreeBox .agree .agreeTop {
		width: 100%;
		height: 95%;
		border-radius: 10px;
		background: #fff;
		padding: 0.34rem;
		overflow: hidden;
	}

	.agreeBox .agree .agreeTop .title {
		color: #4c4c4c;
		font-size: 0.24rem;
		text-align: center;
		margin-bottom: 0.3rem;
	}

	.agreeBox .agree .agreeTop .desc {
		font-size: 0.16rem;
		color: #4c4c4c;
	}

	.agreeBox .agree .agreeTop .agreeContinue {
		width: 80%;
		height: 0.5rem;
		line-height: 0.5rem;
		font-size: 0.2rem;
		text-align: center;
		color: #fff;
		background: #0372ff;
		margin: 0.2rem auto 0 auto;
	}

	.agreeBox .agree .agreeBottom {
		width: 0.6rem;
		height: 0.6rem;
		margin: 0.1rem auto 0 auto;
		cursor: pointer;
	}
</style>
<style>
	/* .el-message-box__header{
        padding-top: 0;
    } */
	.box .el-input__inner {
		border: 0;
		background: rgba(255, 255, 255, 0);
		border-bottom: 1px solid #cccccc;
		border-radius: 0;
		padding-left: 0.46rem;
		font-size: 0.18rem;
		color: #c5cdd3;
	}

	.forget .checkBox .el-checkbox__label {
		color: #c1c9ce;
	}

	.slide-verify {
		width: 456px !important;
	}

	.slide-verify-slider {
		width: 456px !important;
		border-radius: 20px;
	}

	.slide-verify-slider-mask-item {
		width: 60px !important;
		height: 36px !important;
		border-radius: 20px;
		margin-top: 1px;
	}

	.slide-verify-slider-mask-item-icon {
		left: 23px !important;
	}
</style>
